module.exports = "img/feather-customised/warning-triangle.d050a38.svg";